import { FC } from "react";
import { ForgotPassword } from "../../../../modules/authentication/components/forgot-password/forgot-password";

export const ForgotPasswordRoute: FC = () => {
    return (
        <ForgotPassword />
    )
}